import {RESOLVE_LOCALE_FROM_URL, RESOLVE_LOCALE_FROM_PROGRAM} from "../actions";
import {Record} from "immutable";

class ResolvedLocaleState extends Record({
    requestedLocale: null,
    programLocale: null,
    resolvedLocale: 'en-US'
  }) {}

const initialState = new ResolvedLocaleState();

const supportedLocales = ['en-US', 'en-CA', 'fr-CA', 'fr-FR', 'de-DE', 'it-IT', 'en-GB', 'es-ES'];
const supportedLanguages = ['en', 'fr', 'de', 'it', 'es'];
const languageToDefaultLocaleMap = {
  'en': 'en-US',
  'fr': 'fr-CA',
  'de': 'de-DE',
  'it': 'it-IT',
  'es': 'es-ES'
};

const isValidLocale = (locale) => {
  return locale && (supportedLocales.includes(sanitizeLocale(locale)));
};

const sanitizeLocale = (locale) => {
  return locale.replace('_', '-');
};

const resolveLocale = (requestedLocale, programLocale) => {
  requestedLocale = isValidLocale(requestedLocale) ? sanitizeLocale(requestedLocale) : null;
  programLocale = isValidLocale(programLocale) ? sanitizeLocale(programLocale) : null;

  if(requestedLocale) {
    return requestedLocale;
  }
  if(programLocale) {
    return programLocale;
  }
  return 'en-US';

};

const ResolvedLocaleReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case RESOLVE_LOCALE_FROM_URL:
      let locale = action.locale;
      // Check if only a language tag is given, if yes, then use the default locale for that language
      if (languageToDefaultLocaleMap[locale]) {
        locale = languageToDefaultLocaleMap[locale];
      }
      const requestedLocale = isValidLocale(locale) ? sanitizeLocale(locale) : null;
      return state
        .set('requestedLocale', requestedLocale)
        .set('resolvedLocale', resolveLocale(requestedLocale, state.get('programLocale')));
    case RESOLVE_LOCALE_FROM_PROGRAM:
      const programLocale = isValidLocale(action.locale) ? sanitizeLocale(action.locale) : null;
      return state
        .set('programLocale', programLocale)
        .set('resolvedLocale', resolveLocale(state.get('requestedLocale'), programLocale));
    default:
  }

  return state;
};

export const name = 'locale';
export const selector = (state) => state[name];
export default ResolvedLocaleReducer;
